export const valuesData = [
    { title: 'Integrity', description: 'Upholding ethical standards in all operations.' },
    { title: 'Supportive', description: 'Fostering a collaborative environment.' },
    { title: 'Team Work', description: 'Working together for superior results.' },
    { title: 'Professionalism', description: 'Delivering excellence with expertise.' },
    { title: 'Commitment', description: 'Dedicated to customer success and quality.' }
];
